<template>
  <div class="wrapper-page">
    <section class="main-section">

      <div class="p-5 p-lg-3 bg-hero-news d-flex align-items-center justify-content-center text-white">
        <div class="text-center d-flex justify-content-center flex-column align-items-center">
          <h3>
            MONITORAMENTO E MANEJO DA IRRIGAÇÃO PELA 3V3
          </h3>

          <p class="my-4">
            Obtenha sugestões de lâmina todos os dias com a nossa mais nova solução!
          </p>

          <a href="mailto: contato@3v3.com.br?subject=manejo_3v3" class="checkout-btn scale-animation p-2">
            Entre em contato
          </a>

        </div>
      </div>
    </section>

    <div class="wrapper-bg-green pb-5">
      <section v-for="(sectionNew, index) in sections" :key="index" class="bg-alternate-green pt-4 pb-5">
        <!-- <div class="text-center title-green mb-5 mb-lg-0">
          <h2>
            {{sectionNew.title}}
          </h2>
        </div> -->

        <div
          v-for="(sectionExample, index) in sectionNew.items"
          :key="index" class="row mx-3 m-lg-5 py-4"
          :class="`${index % 2 ? 'flex-row-reverse' : ''}`"
          >
          <div class="col-lg-5 px-lg-5 d-flex flex-column justify-content-center">
            <div>
              <h4 class="title-green mb-4">
                {{sectionExample.title}}
              </h4>

              <p class="secondary-text-green mb-4 mb-lg-0">
                {{sectionExample.paragraph}}
              </p>
            </div>
          </div>

          <div class="col-lg-7 pr-lg-5 d-flex align-items-center justify-content-center">
            <div class="w-100 wrapper-border-image">
              <div class="bg-section" :style="`background: url('${sectionExample.image_path}')`"></div>
            </div>
          </div>
        </div>
      </section>

      <div class="d-flex justify-content-center align-items-center text-center pb-5">
        <a
          href="mailto: contato@3v3.com.br?subject=manejo_3v3"
          class="checkout-btn d-flex align-items-center justify-content-center lg-checkout-btn scale-animation p-2"
        >
          Entre em contato
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    mobile: Boolean,
  },
  data() {
    return {
      sections: [
        {
          title: "Manejo",
          items: [
            {
              title: "Monitore suas parcelas de forma rápida e prática",
              paragraph: "Tenha acesso a informações mais relevantes de suas parcelas rapidamente, como por exemplo previsão de excedente, disponibilidade de água no solo, sugestões de tempo de irrigação, dentre outros.",
              image_path: require("../../assets/images/management/management_example_1.jpg")
            },
            {
              title: "Obtenha acesso a gráficos e planilhas detalhados",
              paragraph: "Acompanhe de perto todas as informações relacionadas com o manejo e dados de sensores de solo instalados na área, de forma totalmente integrada. Todas as informações podem ser exportadas para relatórios em formato Excel e Pdf!",
              image_path: require("../../assets/images/management/management_example_2.jpg") 
            },
            {
              title: "Consulte o histórico de suas parcelas a qualquer momento",
              paragraph: "Tenha uma melhor compreensão do comportamento de suas parcelas com o acesso ao histórico de manejo.",
              image_path: require("../../assets/images/management/management_example_3.jpg")
            },
          ]
        }
      ]
    }
  },
  created() {
    this.$emit("title-change", "Novidades");
  }
}
</script>

<style scoped>

.wrapper-bg-green {
  background-color: #EAEFE3;
}

h2 {
  font-size: 2rem;
  font-weight: 600;
  letter-spacing: 0.3rem;
}

.main-section h2 {
  font-size: 2.3rem;
  text-shadow: 0 0 0.1rem #2D6C48;
}


.bg-hero-news h3 {
  font-size: 1.7rem;
  font-weight: 600;
  max-width: 500px;
}

.bg-hero-news p {
  max-width: 400px;
  font-size: 1.3rem;
}

h4 {
  font-size: 1.7rem;
  font-weight: bold;
  max-width: 900px;
}

.bg-hero-news {  
  background: url("../../assets/images/management/d7a2a3_3039f52fa8fb4177bd257ba5d44201d1_mv2.png");
  background-color: rgb(179, 171, 171);
  background-blend-mode: multiply;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  margin: 0 auto;
  aspect-ratio: 1657/531;
  width: 100%;
}

.lg-checkout-btn {
  max-width: 80% !important;
  width: 450px !important;
  height: 50px !important
}

.checkout-btn {
  max-width: 250px;
  width: 90%;
  border-radius: 10px;
  transition: all 0.3s;
  text-decoration: none;
  background-color: #77C692;
  color: white;
}

.checkout-btn:hover {
  filter: brightness(1.05);
  transition: all 0.3s;
}

.bg-alternate-green {
  background-color: #EAEFE3;
}

.title-green {
  color: #2D6C48;
}

.secondary-text-green {
  color: #08120C;
}

section .wrapper-border-image {
  border: 1rem solid white;
  border-radius: 10px;
}

section .bg-section {
  background: url("../../assets/images/management/management_example_1.jpg");
  background-repeat: no-repeat !important;
  background-position: center !important;
  background-size: cover !important;

  transition: all 0.3s;

  aspect-ratio: 1380/816;
  width: 100%;
}

.scale-animation {
  transition: all 0.3s;
  animation: loop-scale 2s infinite;
  animation-fill-mode: forwards;
}

.scale-animation:hover {
  scale: 1.1;
}

.wrapper-page {
  max-height: 100%;
  overflow-y: auto;
  margin: 0 -0.5rem 0 -1rem;
}

section>.row>:first-child>:first-child {
  max-width: 500px;
  margin: 0 auto;
}

@keyframes loop-scale {
/* 0 & 100% might not be needed */
0% {
  scale: 1;
}
50% {
  scale: 1.1;
}
100% {
  scale: 1;
}
}
</style>